export default __webpack_public_path__ + "static/media/Seagull.a2247aa7.png";